module.exports = __webpack_public_path__ + "static/media/2.Aluminium Cables.6b639557.jpg";